import React from 'react'

import Section from '../../../../../../components/Section'
import { Structure } from '../../../../Org/Structure/types'
import { Purchase } from '../../../types'

type Props = {
    theme: string
    purchase: Purchase
    purchaseGuid: string
    structList: Structure[]
}

const formatDate = (isoString: string): string => {
    const date = new Date(isoString)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const PurchaseCardContractInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о закупке">
            <div className="flex flex-col w-full gap-5 mt-2">
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Реестровый номер в ЕИС
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.purchase.registration_number}
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата размещения
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.purchase.publication_date_time
                                ? formatDate(
                                      props.purchase.publication_date_time
                                  )
                                : '-'}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Наименование закупки
                        </div>
                        <div className="flex flex-col w-full gap-3 items-start justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            <p className="fourrow">{props.purchase.name}</p>
                        </div>
                    </div>
                </div>
                {props.purchase.appl_submision_start_date ? (
                    <div className="flex flex-row w-full gap-5">
                        <div className="flex flex-col w-1/2">
                            <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата начала подачи заявок
                            </div>
                            <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                {props.purchase.appl_submision_start_date
                                    ? formatDate(
                                          props.purchase
                                              .appl_submision_start_date
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="flex flex-col w-1/2">
                            <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата окончания подачи зявок
                            </div>
                            <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                {props.purchase.submission_close_date_time
                                    ? formatDate(
                                          props.purchase
                                              .submission_close_date_time
                                      )
                                    : '-'}
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Способ закупки
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.purchase.purchase_method_name}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Сумма закупки
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {/* {formatNumber(props.purchase.price)} */} руб.
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Версия сведений
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.purchase.version}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default PurchaseCardContractInfo
